module.exports = __webpack_public_path__ + "static/media/G1-36-Chuva-de-Flechas-cod72.367ef482.png";